export default __webpack_public_path__ + "static/media/warning.edc9eeb3.svg";